import { BreadcrumbItem } from '@/contexts/NavigationContext';

export interface BreadcrumbConfig {
  [key: string]: {
    label: string;
    parent?: string;
    dynamic?: boolean;
    hideFromBreadcrumb?: boolean;
  };
}

export const breadcrumbConfig: BreadcrumbConfig = {
  '/': {
    label: 'Home',
  },
  '/dashboard': {
    label: 'Dashboard',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/company': {
    label: 'Company',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/valuations': {
    label: 'Valuations',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/plan': {
    label: 'Plan',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/documents': {
    label: 'Documents',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/tasks': {
    label: 'Tasks',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/team': {
    label: 'Team',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/learn': {
    label: 'Learn',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/settings': {
    label: 'Settings',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/assessment': {
    label: 'Getting Started',
    parent: '/',
    hideFromBreadcrumb: true,
  },
  '/profile': {
    label: 'Profile',
    parent: '/',
  },
};

export function generateBreadcrumbs(pathname: string, searchParams?: URLSearchParams): BreadcrumbItem[] {
  const breadcrumbs: BreadcrumbItem[] = [];
  
  const config = breadcrumbConfig[pathname];
  if (config) {
    // Build breadcrumb chain
    const chain = buildBreadcrumbChain(pathname);
    
    chain.forEach((path, index) => {
      const pathConfig = breadcrumbConfig[path];
      if (pathConfig && !pathConfig.hideFromBreadcrumb) {
        const isLast = index === chain.length - 1;
        breadcrumbs.push({
          label: pathConfig.label,
          href: isLast ? undefined : path,
          isActive: isLast,
        });
      }
    });
  } else {
    // Fallback for unknown routes
    const segments = pathname.split('/').filter(Boolean);
    let currentPath = '';
    
    segments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const isLast = index === segments.length - 1;
      
      breadcrumbs.push({
        label: formatSegmentLabel(segment),
        href: isLast ? undefined : currentPath,
        isActive: isLast,
      });
    });
  }
  
  return breadcrumbs;
}

function buildBreadcrumbChain(pathname: string): string[] {
  const chain: string[] = [];
  let currentPath = pathname;
  
  while (currentPath && currentPath !== '/') {
    chain.unshift(currentPath);
    const config = breadcrumbConfig[currentPath];
    currentPath = config?.parent || '/';
  }
  
  // Only add home if we're not already on home and there are other items
  if (pathname !== '/' && chain.length > 0) {
    chain.unshift('/');
  }
  
  return chain;
}

function formatSegmentLabel(segment: string): string {
  return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
}